import { Box, Button, FormControl, Grid, TextField, Typography } from "@mui/material";
import React, { useState, useContext } from "react";
import AutocompleteAsync from "../controls/autocompleteasync";
import ComponentContainer from "./componentContainer";
import AddIcon from '@material-ui/icons/Add';
import globalContext from "./globalContext";
import LineIcon from "react-lineicons";
import SaveIcon from '@mui/icons-material/Save';
import ExitToApp from "@mui/icons-material/ExitToApp";
import AlertDialog from "./alertdialog";
import ErrorIcon from '@mui/icons-material/Error';
import api from "../util/api";

export default function KPDKlasifikacijaForm(props) {

    const global = useContext(globalContext);

    const setFormOpened = props.setFormOpened;
    const reload = props.reload;

    const [loading, setLoading] = useState(false);
    const [searchURL, setSearchURL] = useState("");
    const [selectedKPD, setSelectedKPD] = useState(null);
    const [errorMessage, setErrorMessage] = useState("");

    function onSearchTextChange(e,v) {
        setSearchURL("/kpd/searchNew?text=" + v + "&firmaID=" + global.user.firmaID);
    }

    function save() {
        setLoading(true);
        api.post("kpd/add", { FirmaID: global.user.firmaID, KPDKlasifikacijaID: selectedKPD.KPDKlasifikacijaID }, saveSuccess, saveFail);
    }

    function saveSuccess() {
        reload();
        setFormOpened(false);
    }

    function saveFail(data) {
        setErrorMessage(data ? (data.Message || data.toString()) : "");
        setLoading(false);
    }

    return (
        <ComponentContainer loading={loading}>
            <Grid container spacing={1}>
                <Grid item xs={12} textAlign="center">
                    <Typography variant="h5" gutterBottom component="div">
                        <AddIcon fontSize="small" /> Dodavanje KPD klase
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <FormControl fullWidth>
                        <AutocompleteAsync
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.KPDKlasifikacijaID}>
                                        {option.Oznaka + " - " + option.Opis}
                                    </li>
                                );
                            }}
                            api={searchURL}
                            onChange={(e,v) => setSelectedKPD(v)}
                            onInputChange={onSearchTextChange}
                            size="small"
                            value={selectedKPD}
                            getOptionLabel={(option) => option.Oznaka + " - " + option.Opis}
                            name="KPD klasa"
                            error={!selectedKPD || typeof(selectedKPD) != "object"}
                            renderInput={(params) => <TextField {...params} label="KPD klasa" />}
                        />
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Box display="flex" justifyContent="flex-end" width="100%" marginTop="10px" >
                        <Button onClick={save} variant="contained" style={{marginRight:"10px"}} color="success" disabled={loading || !selectedKPD}>{loading ? <LineIcon size="sm" name="spiner-solid lni-is-spinning" style={{marginRight:"10px"}} /> : <SaveIcon style={{marginRight:"10px"}} />} Spremi</Button>
                        <Button variant="outlined" color="error" onClick={() => setFormOpened(false)} disabled={loading}><ExitToApp style={{ marginRight:"10px"}}></ExitToApp>Zatvori</Button>
                    </Box>
                </Grid>
            </Grid>

            {errorMessage != null && errorMessage != "" ? <AlertDialog title="Greška" icon={<ErrorIcon style={{marginRight:"15px", color:"red"}}></ErrorIcon>} message={errorMessage} cancelHidden={false} confirmHidden={true} okHidden={true} cancelLabel={"Zatvori"} cancelAction={() => setErrorMessage("")}></AlertDialog> : null}
        </ComponentContainer>
    );
}